<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path d="M22 7.78062L25.8528 16.0768L26.0285 16.4552L26.4428 16.5054L35.5234 17.606L28.8239 23.8338L28.5183 24.1179L28.5986 24.5274L30.3579 33.5037L22.3646 29.0566L22 28.8537L21.6354 29.0566L13.6421 33.5037L15.4014 24.5274L15.4817 24.1179L15.1761 23.8338L8.47657 17.606L17.5572 16.5054L17.9715 16.4552L18.1472 16.0768L22 7.78062Z" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>

</template>
